import { createSlice } from '@reduxjs/toolkit';
import type { DbParticipation } from '@hub/common';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ErrorData } from 'features/error-handling/types/ErrorData';

type ParticipationState = {
  docData?: DbParticipation;
  errorData?: ErrorData;
  documentNotFound: boolean;
};

const initialState: ParticipationState = {
  documentNotFound: false,
};

// TODO: Consider removing this slice if just the state from document API slice will be enough
const participationSlice = createSlice({
  name: 'participation',
  initialState,
  reducers: {
    restoreInitialState: () => initialState,
    snapshotReceived: (state, action: PayloadAction<DbParticipation>) => {
      state.docData = action.payload;
      state.documentNotFound = false;
    },
    errorOccurred: (state, action: PayloadAction<ErrorData>) => {
      state.errorData = action.payload;
    },
    documentNotFound: state => {
      state.documentNotFound = true;
    },
  },
});

export const {
  restoreInitialState,
  snapshotReceived,
  errorOccurred,
  documentNotFound,
} = participationSlice.actions;

export const participationReducer = participationSlice.reducer;
